import { render, staticRenderFns } from "./TotalLinkedReferralsperEmployee.vue?vue&type=template&id=6a517976&"
import script from "./TotalLinkedReferralsperEmployee.vue?vue&type=script&lang=js&"
export * from "./TotalLinkedReferralsperEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports